<div mat-dialog-title class="search-dialog-header">
  <div class="search-dialog-header__content">
    <mat-form-field class="search-input" floatLabel="always" [subscriptSizing]="'dynamic'">
      <svg class="icon-24 margin--right-xs" matPrefix><use href="assets/images/ok-icons-sprite.svg#search-s"></use></svg>
      <mat-label>Søg</mat-label>
      <input matInput type="text" #queryElement id="search-input" [formControl]="queryControl" />
      @if (queryControl.value) {
        <button matSuffix mat-icon-button aria-label="Ryd søgning" (click)="resetQuery()">
          <svg class="icon-20" matPrefix><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
        </button>
      }
    </mat-form-field>
    @if (isSearching()) {
      <div class="loading-indicator-container">
        <div class="loading-indicator" aria-live="polite">
          <span class="spinner"></span>
        </div>
      </div>
    }
  </div>
  <button class="search-dialog-close" type="button" (click)="closeDialog()">
    <svg class="icon-24" matPrefix><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
  </button>
</div>

<section class="search-dialog-content" role="region" aria-label="Søgeresultater">
  @for (quickSearchResult of quickSearchResults(); track $index) {
    <article class="search-result-category" [admRequiresFeatureRole]="permissionMap()[quickSearchResult.searchResultType]">
      <header class="search-result-category__header">
        <h2 class="search-result-category__header-title">{{ quickSearchResult.searchResultType | translateSearchResultType }}</h2>
      </header>
      @if (quickSearchResult.quickSearchResponses.length > 0) {
        <ul class="search-result-category__list">
          @for (searchResultItem of quickSearchResult.quickSearchResponses; track $index) {
            <li class="search-result-item">
              <span class="search-result-item__header">
                @if (searchResultItem.routerLink) {
                  <a
                    [routerLink]="searchResultItem.routerLink"
                    [queryParams]="searchResultItem.queryParameters"
                    (click)="closeSearchAndSearchResults()"
                    class="search-result-item__primary-link">
                    {{ searchResultItem.name }}
                  </a>
                } @else {
                  <span class="ssearch-result-item__primary-link"> {{ searchResultItem.name }} </span>
                }

                @if (
                  searchResultItem.mapQueryParameters &&
                  !searchResultItem.restricted &&
                  quickSearchResult.searchResultType === searchResultTypeEnum.ChargingStationLocation
                ) {
                  <a
                    [routerLink]="['/ok-app-emulator']"
                    [queryParams]="searchResultItem.mapQueryParameters"
                    (click)="closeSearchAndSearchResults()"
                    class="search-result-item__emulator-link">
                    <mat-icon class="google-maps-link-icon--middle-small" [matTooltip]="'Vis i app emulator'">travel_explore</mat-icon>
                  </a>
                }
              </span>

              <div class="search-result-item__details">
                @if (searchResultItem.description && searchResultItem.description !== searchResultItem.organizationName) {
                  <div class="search-result-item__detail">
                    @if (quickSearchResult.searchResultType === searchResultTypeEnum.ChargingUser) {
                      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
                    }
                    <span>{{ searchResultItem.description }}</span> kk
                  </div>
                }

                @if (searchResultItem.address && quickSearchResult.searchResultType !== searchResultTypeEnum.ChargingStationLocation) {
                  <div class="search-result-item__detail">
                    <svg title="Adresse" class="icon-20"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
                    <span>{{ searchResultItem.address }}</span>
                  </div>
                }

                @if (
                  searchResultItem.address &&
                  !searchResultItem.restricted &&
                  quickSearchResult.searchResultType === searchResultTypeEnum.ChargingStationLocation
                ) {
                  <a
                    [routerLink]="okAppEmulatorRouterLink"
                    [queryParams]="{
                      chargingStationLocationIdentifier: searchResultItem.identifier,
                    }"
                    (click)="closeSearchAndSearchResults()"
                    class="search-result-item__detail search-result-item__detail--link">
                    <svg title="Lokation" class="icon-20"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
                    <span>{{ searchResultItem.address }}</span>
                  </a>
                }

                @if (
                  searchResultItem.address &&
                  searchResultItem.restricted &&
                  quickSearchResult.searchResultType === searchResultTypeEnum.ChargingStationLocation
                ) {
                  <div matTooltip="Lokationen er begrænset" class="search-result-item__detail search-result-item__detail--restricted">
                    <svg title="Lokation" class="icon-20"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
                    <span>{{ searchResultItem.address }}</span>
                    <mat-icon title="Begrænset">security</mat-icon>
                  </div>
                }

                @if (searchResultItem.description2) {
                  <div class="search-result-item__detail">
                    @if (quickSearchResult.searchResultType === searchResultTypeEnum.ChargingStationLocation) {
                      <mat-icon svgIcon="sell_outlined" aria-hidden="false" title="Prispolitik"></mat-icon>
                    }
                    @if (quickSearchResult.searchResultType === searchResultTypeEnum.PricePolicy) {
                      <mat-icon svgIcon="sell_outlined" title="Pris"></mat-icon>
                      <span>{{ searchResultItem.description2 | dkCurrency }} pr kWh</span>
                    } @else {
                      @if (quickSearchResult.searchResultType === searchResultTypeEnum.ChargingUser) {
                        <span>MOK brugernr.: {{ searchResultItem.description2 }}</span>
                      } @else {
                        <span>{{ searchResultItem.description2 }}</span>
                      }
                    }
                  </div>
                }

                @if (searchResultItem.organizationName) {
                  <a
                    [routerLink]="organizationRouterLink"
                    [queryParams]="{
                      organizationId: searchResultItem.organizationId,
                    }"
                    (click)="closeSearchAndSearchResults()"
                    class="search-result-item__detail search-result-item__detail--link">
                    <svg class="icon-20" matPrefix><use href="assets/images/ok-icons-sprite.svg#building-s"></use></svg>
                    <span>{{ searchResultItem.organizationName }}</span>
                  </a>
                }

                @if (searchResultItem.departmentName) {
                  <a
                    [routerLink]="departmentRouterLink"
                    [queryParams]="{
                      organizationId: searchResultItem.organizationId,
                      departmentId: searchResultItem.departmentId,
                    }"
                    (click)="closeSearchAndSearchResults()"
                    class="search-result-item__detail search-result-item__detail--link">
                    <mat-icon svgIcon="apartment_outlined" title="Afdeling"></mat-icon>
                    <span>{{ searchResultItem.departmentName }}</span>
                  </a>
                }
              </div>
            </li>
          }
        </ul>
      } @else {
        <div class="search-result-category__no-results">Søgningen gav ingen resultater</div>
      }
    </article>
  }
</section>
